//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
let d=[[[0,"Entity",0,"DisplayableObject",0],[0,"UsageStatus",0,0]],[[["typeOfUsage","nDependentFeatures","dependentFeatures","detailedUsageInfo"],"GetDependentFeatures",{},1,0],[["typeOfUsage","nOtherDependents","otherDependents","detailedUsageInfo"],"GetOtherDependents",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.EntityUsageInfo = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.EntityUsageInfo";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.EntityUsageInfo.Status = Object.freeze({
    "Unused" : "Unused", "IntraPart" : "IntraPart", "InterPart" : "InterPart"});

export default SPLM;